 
import CommonStyles from "../../../styles/CommonStyles.css";
import TableStyles from "../../../styles/TableStyles.css";
 


export const styles = (theme) => ({
 
  ...TableStyles,
  ...CommonStyles,
  
  usersHeader:{
    display:"flex",
    background: "#292929",
    alignItems: "center",
    padding: "11px 10px",
  },
  usersProfileImage:{
    margin:"0 10px"
  },
  globalCreateBody:{
    background:"#000",
    // height: "100vh",
  },
  globalInput: {
    width:"100%",
    padding: "0",
    "& input": {
      borderRadius: "5px !important",
      padding: "10px",
       fontSize:"1em",
      background:"#2d2d2d"
    },
    "& .MuiAutocomplete-inputRoot":{
      background: "#2d2d2d",
    },
    "& div": {
      borderRadius: "5px",
      width:"-webkit-fill-available !important",
      width:"100%",
      boxSizing: "border-box",
    },
    "& .MuiSelect-outlined.MuiSelect-outlined":{
      padding:"12px",
      background:"#2d2d2d"
    },    
    "& div.MuiAutocomplete-endAdornment":{
      width:"auto !important",
    },
    "& div.MuiCircularProgress-indeterminate":{
      width:"20px !important",
      height:"20px !important",
      color: "green",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
      borderColor: "#46af22 !important",
    },
    "&  .MuiAutocomplete-inputRoot": {
      padding:" 2px 9px",
  },
  },
  userProfileImage: {
    padding: "0px",
    maxWidth: "150px",
    minHeight: "150px",
    borderRadius:" 50% !important",
    marginBottom: "20px",
    margin:" 0 auto",
    background: "none",
    color: "#b9b9b9",
    width:"100%",
    border: "2px solid #757575",
    "& img":{
      borderRadius:" 90%",
    }
  },
  addedUsersName:{
    maxWidth:"150px",
    textOverflow:"hidden",
    overFlow:"hidden",
  },
  userNotes:{
    background:"#000",
    borderRadius:"3px",
    width: "97%",
    border: "1px solid #3b3b3b",
    color:"#fff",
    padding: "10px",
    "&:focus":{
      border:"1px solid #46af22",
      outline: "none",
    }
  },
  userName:{
    textAlign:"center",
    display: "block",
  },
  userTabsAll:{
    color:"#fff",
    "& .MuiTab-textColorPrimary.Mui-selected":{
      color:"#fff",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "#279F04",
  }
  },
  usersButtonsList:{
    textAlign:"right",
    padding: "0 25px",
  },
  globalBlock:{
    display:"flex",
    alignItems:"flex-end",
    "& > div":{
      padding: "0 10px",
    },
    "& > div > div.MuiInput-root":{
      margin:"0",
    }
  },
  toolsInnerWrap: {
    background: "#636363",
    borderRadius: "5px",
    marginRight:"5px",
    float: "left",
    padding: "3px 5px",
    minWidth: "230px",
     fontSize:"0.8em",
    marginLeft:"6px",
    "& div:before": {
        outline: "none",
        border: "none !important",
        width: "100%",
    },
    "& .MuiInput-underline:after": {
        borderBottom: "2px solid #0C853E",
    },
    "& div": {
        width: "100%",
    },
    "& input": {
        width: "100%",
        padding: "5px 8px",
         fontSize:"0.8em",
        fontWeight: "300",
    },
  },
  tableMainView: {
    overflow: "auto",
    width: "100%",
    marginTop: "53px",
    background: "#000",
    position: "absolute",
    height: "calc(100% - 60px)",
    "& .MuiAvatar-square":{
      background: "#d8d8d5",
      borderRadius: "3px",
         },
     "& td":{
          cursor: "pointer",
          padding: "3px 10px",
          fontSize: "11px",
          textAlign: "left",
          wordBreak: "normal",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
    
  },
 
  dialogWrapper:{
    fontSize:"12px",
  },
  dialogYesButton:{
    background:"#118543",
    "&:hover":{
      background:"#000",
      color:"#118543",
    }
  },
  dialogNoButton:{
    background:"#505050",
    "&:hover":{
      background:"#000",
      color:"#fff",
    }
  }, 
  editIcon:{
    position:"absolute",
    top:"0",
    right: "0",
    background:"#0C853E",
    "& button":{
      position:"absolute",
    top:"0",
    right: "-80px",
    background: "#000",
    color:" #fff",
    },
    "& svg":{
    color:" #fff",
    fontSize:"15px",
    },
  },
  userProfileEdit: {
    margin: "50px auto 15px auto",
    display: "block",
    maxWidth: "150px",
    position:"relative",
    "& button":{
      right: "20px",
    top: "6px",
    },
  },  
  addUserContainer:{
    padding:"10px 0px 15px 5px",
    "& hr":{
      margin: "10px 0 20px 0",
      background: "#5d5d5d",
    }
  },
  heading:{
    fontSize:"0.8em",
    marginTop:"18px",  
    borderBottom: "1px solid #696969",
    display: "block",
    paddingBottom: "5px",
    marginBottom: "5px",
    color:"#FCE939",
    textTransform:"uppercase"
  },
  mainHeader:{
    fontSize:"14px",
    marginTop:"18px",   
    display: "block",
    paddingBottom: "0",
    marginBottom: "0",
    color:"#FCE939",
    textTransform:"uppercase"
  },
  helpTrashButton:{
    minWidth: "inherit",
    width: "32px",
    height: "32px",
    border:"1px solid #4c4c4c",
    marginBottom:"10px",
    borderRadius:"3px"
  },
  widthOverride:{
      padding: "0 15px",
  },
  usersButtonsMarginBottom:{
    marginBottom:"10px",
  },
  selecBoxOverride:{
    "& .MuiInput-root":{
      padding:"2px",   
      background: "#2d2d2d",
      border: "1px solid #5e5e5e",
      "& .MuiSelect-icon":{
        right: "8px",
        },
      "&:hover":{
        border:"1px solid #46af22 !important",
      },
      "&.Mui-focused":{
        border:"1px solid  #46af22 !important",
      },
    },
  },
  helpInputContainer:{
    display:"flex",
    "& label":{
      margin:"10px 0 5px 0",
    },
    "& div":{
      margin:"0",
    },   
    "& .MuiInput-root":{
      padding:"2px",
      width: "95% !important",
      background: "#2d2d2d",
      border: "1px solid #5e5e5e",     
      "&:hover":{
        border:"1px solid #46af22 !important",
      },
      "&.Mui-focused":{
        border:"1px solid  #46af22 !important",
      },
    },
    "& button":{
      minWidth: "inherit",
      width: "30px",
      height: "30px"
    },
    "& textarea": {
      background: "#2d2d2d",
      boxSizing: "border-box",
      maxWidth:"100%",
      resize:"none",
      borderRadius: "3px",
      maxHeight:"220px",
      width: "-webkit-fill-available",
      width:"100%",
      color: "#fff",
      padding: "10px",
      border: "1px solid #5e5e5e",
      fontFamily:
        "'Roboto', 'Helvetica', 'Arial',  sans-serif , 'Segoe UI', 'Roboto', 'Oxygen'",
      fontSize: "12px",
      "&:focus":{
        outline:"none",
        border:"1px solid #46af22 ",
      },
      "&:hover":{
        outline:"none",
        border:"1px solid #46af22 ",
      }
    },
  },
  helpMainContainer:{
    padding:"0 20px",
    marginTop:"10px",
  },
  helpLocationItems:{
    display:"flex",
    fontSize:"12px",
    alignItems:" center",
    background: "#232323",
    padding: "8px 10px",
    marginBottom: "2px",
    "& svg":{
      width: "15px",
      minWidth: "inherit",
      height: "15px"
    }
  },
  helpLocationContainer:{
    marginTop:"20px",
  },
  closeButton: {
    background: "transparent",
    boxShadow: "none",
    color: "#F8F8F8",
    textTransform: "none",
    float: "right",
    fontWeight: "400",
    minWidth: "0px",
    padding: "7px 10px !important",
    width:"32px",
    marginLeft: "10px",
    border:"1px solid #525252",
    "& svg":{
      fontSize: "16px",
    },
    "&:hover": {
      background: "#000",
      boxShadow: "none",
    },
  },
  moduleTitleMargin:{
    marginTop: "20px",
  },

  helpParaWrap:{
    userSelect: "auto"
  },
  labelMinWidth:{
    minWidth:"300px",
  },
  resultsTabsButtons:{
    background:"#353535",
    "& .MuiTabs-indicator":{
      backgroundColor: "#0c853e",
    },
    "& .MuiButtonBase-root":{
      fontSize:"12px",
    }

  },
  trackTabsHeader:{
    background:"#3e3e3e",
    borderRadius:"4px",
    "& .MuiBox-root":{
      padding:"12px"
    }
  },
  globalBlockAutoWidth:{
    width:"100% ",
    paddingBottom:"15px",
    paddingRight:"10px",
    "& > div":{
      width:"100% ",
    }
  },

  contentRequestStatus:{
    fontSize: "11px",
    color:"#fff !important",
    fontWeight:"normal !important",
    display: "block",
    padding: "3px 5px",
    borderRadius: "3px",
    marginTop: "5px",
    textAlign: "center",
    boxSizing: "border-box",
    minWidth: "auto",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign:"center"
  },
  contentRequested:{
    background:"#0c853e",
    fontSize: "11px",
    color:"#fff !important",
    fontWeight:"normal !important",
    display: "block",
    padding: "3px 5px",
    borderRadius: "3px",
    marginTop: "5px",
    textAlign: "center",
    // float: "right",
    boxSizing: "border-box",
    minWidth: "auto",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign:"center"

  },
  contentNotsourced:{
    background:"#953c3c",
    color:"#fff !important",
    fontWeight:"normal !important",
    fontSize: "11px",
    display: "block",
    padding: "3px 5px",
    borderRadius: "3px",
    marginTop: "5px",
    textAlign: "center",
    // float: "right",
    boxSizing: "border-box",
    minWidth: "90px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign:"center !important"
  },
  contentAcknowledged:{
    background:"#705200",
    color:"#fff !important",
    fontWeight:"normal !important",
    fontSize: "11px",
    display: "block",
    padding: "3px 5px",
    borderRadius: "3px",
    marginTop: "5px",
    textAlign: "center",
    // float: "right",
    boxSizing: "border-box",
    minWidth: "90px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign:"center"
  },
  contentSuccessful:{
    background:"#015C6A", 
    color:"#fff !important",
    fontWeight:"normal !important",
    fontSize: "11px",
    display: "block",
    padding: "3px 5px",
    borderRadius: "3px",
    marginTop: "5px",
    textAlign: "center",
    // float: "right",
    boxSizing: "border-box",
    minWidth: "70px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign:"center"
  },
  contentRejected:{
    background:"#A22F2F", 
    color:"#fff !important",
    fontWeight:"normal !important",
    fontSize: "11px",
    display: "block",
    padding: "3px 5px",
    borderRadius: "3px",
    marginTop: "5px",
    textAlign: "center",
    // float: "right",
    boxSizing: "border-box",
    minWidth: "90px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign:"center"
  },
// /////////////////////////////////////

tagCloud: {
  width: "90%",
  margin: "auto",
},
tagSearchMenuItem: {
  color: "white",
  background: "#313131",
  fontSize:"12px !important",
},

noData: {
  top: "50%",
  left: "0",
  right: "0",
  width: "100%",
  // bottom: "0",
  position: "absolute",
  fontSize: "12px",
  textAlign: "center",
},

tagCloudTag: {
  "&:hover": {
    color: "#5ed890",
    cursor: "pointer",
    "& span": {
      color: "white",
    },
  },
},

tagCloudPlus: {
  color: "#5ed890",
  margin: "0 3px",
},
commonTopButton: {
  padding: "9px",
  height: "32px",
  width: "32px",
  minWidth: "inherit",
  marginTop: "7px",
  marginLeft: "0px",
},
closeRightButton:{
  marginTop:"8px !important",
},
buttonCustomSize: {
  "& svg": {
    fontSize: "16px !important",
  },
},
tagsFilterWrapper: {
  display: "flex",
  alignItems: "center",
  padding: "10px",
  background: "#313131",
},
reqAddButton:{
  width: "auto !important",
  float: "left",
  marginTop: "10px",
  fontSize: "0.75em",
  padding: "5px 10px ",
  fontWeight: "400",
  minWidth: "90px ",
  textTransform: "none",
  background: "#008135",
  border:"1px solid #008135",
  "& svg":{
    marginRight: "5px",
  },
  "&:hover":{
    background: "#04923F",
    border:"1px solid #008135",
  }
},
tagSearchButton: {
  minWidth: "inherit",
  padding: " 8px 10px 8px 10px",
  marginLeft: "10px",
  width: "36px",
  "&:hover": {
    background: "#04923F",
    color: "#fff",
  },
  "& svg": {
    fontSize: "16px",
  },
  "& .MuiCircularProgress-colorPrimary": {
    color: "#fff",
    width: "10px !important",
    margin: "0 !important",
    height: "10px !important",
  },
},
tagSearchArea: {
  boxSizing:"border-box",
  padding: "15px",
  background: "#313131",
  alignItems: "start",
  position:"relative",
  zIndex:"99", 
  marginBottom: "0px",
 
  "& .MuiListItem-button:hover": {
    background: "#424242",
  },
  "& .MuiListItem-button .active": {
    background: "#424242",
  },
  "& .MuiChip-outlined": {
    border: " 1px solid rgb(255 200 0)",
    fontSize: "0.75em",
    backgroundColor: "transparent",
    height: "30px",
    "& .MuiChip-label": {
      color: "rgb(255 200 0)",
    },
  },
  "& .dropdown-menu a.disabled": {
    background: "#383838",
    padding: "10px",
    fontSize: "0.75em",
    display: "block",
    color: "#ffcb0e",
    border: " 1px solid #6d6a6a",
    borderTop: "none",
    borderRadius: "0px 0px 3px 3px",
  },
  "& .MuiChip-root": {
    fontSize: "0.75em",
    marginRight: "5px",
    marginBottom: "5px",
  },
  "&  input": {
    padding: "9px 12px",
    background: "#5a5a5a",
    borderRadius: "3px",
    color: "#fff",
    border: "1px solid rgba(255, 255, 255, 0.23)",
    fontSize: "0.75em",
    width: "100%",
    boxSizing: "border-box",
  },
  "& input:focus": {
    borderColor: "#46af22 !important",
    outline: "none",
  },
  "& input:hover": {
    borderColor: "#46af22 !important",
  },
},
appbarinforDisplay:{
  padding:"15px 15px 0 15px",
  fontSize:"12px",
  "& > span":{
    display:"block",
    marginBottom: "0px",
  },
  "& button":{
    marginLeft:"0",
  }
},
tagsChipsPreview: {
  marginTop: "10px",
},
tagsClearButton: {
  "&.Mui-disabled": {
    opacity: "0.5",
  },
  minWidth: "inherit",
  width: "34px",
  margin: "0 5px 0 10px",
  height: "35px",
  "& svg": {
    fontSize: "16px",
  },
  "&:hover": {
    background: "#04923F",
    color: "#fff",
  },
},
muTitle:{
  color: "#fff",
  fontSize: "0.88em",
  fontWeight: "500",
  width: "-webkit-fill-available",
  width:"100%",
  padding: "10px 15px 10px 15px !important",
  overflow: "hidden",
  textOverflow: "ellipsis",
  margin: "0",
  textAlign:"left"
},
muListWrapUploads: {
  padding: " 20px 20px !important",
  width: "calc(100% - 40px)",
  background: "#181818 !important",
  position: "relative",
  overflow: "auto",
  height: "calc(100% - 92px)",
  "& h4":{
    margin: "0 0 10px 0",
    padding: "0 0 10px 0",
    fontWeight: "500",
    borderBottom: "1px solid #636363",
    fontSize: "15px"
  },
  "& .MuiCircularProgress-colorPrimary": {
    color: "green",
    position: "absolute",
    right: "0",
    textAlign: "center",
    margin: "50px auto",
    left:"0",
}
},
paperwrap: {
  position: "relative",
  height: "100vh",
  width: "calc(100% - 0px) !important",
  background: "none",
  boxShadow: "none",
},
muDetails: {
  width: "80%",
  display: "inline-block",
  verticalAlign: "top",
  fontSize: "0.75em",
  wordBreak:"break-all",
},
muDetailWrap:{
  display: "flex",
  padding: "8px 0",
  borderBottom: "1px solid #353535 !important",
},
buttonContainer:{
  paddingTop:"20px",
  "& button":{
    margin:"0 10px 0 0px"
  }
},
albumSearchInputBlock:{
  width:"-webkit-fill-available",
  width:"100%",
  width:"100%",
  zIndex:"9",
  "& > div":{
    display:"flex",
    width:"-webkit-fill-available",
    width:"100%",
    "& > div":{
      width:"-webkit-fill-available",
      "& > div:after":{
        display:"none",
      },
      "& > div:before":{
        display:"none",
      }
    },
  },
  "& .MuiButton-text":{
    marginTop:"0px !important",
  },
  
},
albumSearchArea: {
  display: "flex",
  padding: "15px 5px 12px 15px",
  background: "#313131",
  // maxHeight: "300px",
  // overflow: "auto",
  alignItems: "start",
  marginBottom: "0px",
  "& .MuiButtonBase-root":{
    marginTop:"0px !important",
  },
  "& .MuiListItem-button:hover": {
    background: "#424242",
  },
  "& .MuiListItem-button .active": {
    background: "#424242",
  },
  "& .MuiChip-outlined": {
    border: " 1px solid #00a5ef",
    fontSize: "12px",
    backgroundColor: "transparent",
    height: "30px",
    maxWidth:"130px",
    background:"#0079af !important",
    "& .MuiChip-label": {
      color: "#fff",
    },
  },
  "& .dropdown-menu a.disabled": {
    background: "#383838",
    padding: "10px",
    fontSize: "12px",
    display: "block",
    color: "#ffcb0e",
    border: " 1px solid #6d6a6a",
    borderTop: "none",
    borderRadius: "0px 0px 3px 3px",
  },
  "& .MuiChip-root": {
    fontSize: "12px",
    marginRight: "5px",
    marginBottom: "5px",
    marginLeft: "5px",
  },
  "&  input": {
    padding: "9px 12px",
    background: "#5a5a5a",
    borderRadius: "3px",
    color: "#fff",
    border: "1px solid rgba(255, 255, 255, 0.23)",
    fontSize: "12px",
    width: "100%",
  },
  "& input:focus": {
    borderColor: "#46af22 !important",
    outline: "none",
  },
  "& input:hover": {
    borderColor: "#46af22 !important",
  },
},
reqName:{
  fontSize:"0.8em",
  width: "100%",
},
albumDisplayList:{
  fontSize:"1em",
  marginBottom: "2px",
  padding: "5px",
  marginRight:"0",
  borderRadius: "4px",
  "& .MuiFormControlLabel-label":{
    textAlign:"left",
    display: "flex",
    width: "100%",
    alignItems: "center",
  },
  "& .MuiFormControlLabel-root":{
    marginBottom: "5px",
    borderBottom: "1px solid #3c3c3c",
    paddingBottom: "10px",
    margin:"0",
  },
  "& h3":{
    margin:"0",
    padding:"0",
    fontSize:"1em",
  },
  "& .MuiAvatar-square":{
    width: "22px",
    height: "22px",
    margin: "0 10px",
  }
},
albumName:{
  width:"100%",
  width:"-webkit-fill-available",
},
albumNameWBreak:{
  wordBreak: "break-word",
},
albumcatId:{
  minWidth: "80px",
  textAlign: "right",
  paddingRight: "10px",
},
circularProgressIcon:{
  width:"40px",
  height:"40px",
  color:"green",
  position:"absolute",
  top:"50%",
  left:"0",
  right:"0",
  margin:"0 auto",
},
noResults:{
  fontSize:"12px",
  textAlign:"center",
  padding:"50% 0"
},
messagePagination:{
  "& .MuiTablePagination-input":{
    marginRight:"12px",
    marginLeft: "0px",
  },
  "& .MuiTablePagination-actions":{
    marginLeft: "10px",
  },
  "& .MuiToolbar-gutters":{
    paddingLeft: "10px",
  },
  "& .MuiSelect-select":{
    background:"#5d5d5d",
    borderRadius: "3px",
  },
  "& .Mui-focused .MuiSelect-select":{
    background:"#807f7f",
  }
},
columnMsgButton:{
  width:"30px",
  height:"30px",
  "& div":{
    margin: "0 !important",
    padding:" 0 !important",
    display: "block !important",
    verticalAlign: "top !important",
    width:"inherit !important",
  height:"inherit !important", 
  }
}
});

 
  
